<template>
  <div class="gauge-inner">
    <div class="gauge-svg-wrap">
      <svg viewBox="0 0 110 64" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 56 A45 45 0 0 1 100 56"
          fill="none" stroke="#e8eaf6" stroke-width="10" stroke-linecap="round"/>
        <path d="M10 56 A45 45 0 0 1 100 56"
          fill="none" :stroke="color" stroke-width="10" stroke-linecap="round"
          :stroke-dasharray="arcLength" :stroke-dashoffset="dashoffset"
          style="transition: stroke-dashoffset 0.8s ease, stroke 0.4s ease"/>
      </svg>
      <div class="gauge-label">
        <span class="gauge-pct" :style="{ color }">{{ pctLabel }}</span>
        <span class="gauge-sub">cumplimiento</span>
      </div>
    </div>
    <div class="gauge-counts">
      <div class="gauge-count si"><i class="bi bi-check-circle-fill"></i> SI <strong>{{ si }}</strong></div>
      <div class="gauge-count no"><i class="bi bi-x-circle-fill"></i> NO <strong>{{ no }}</strong></div>
    </div>
  </div>
</template>



<script>
const ARC_LENGTH = Math.PI * 45;

export default {
  name: 'GaugeChart',
  props: { valores: Array },
  computed: {
    si()         { return this.valores?.[0] ?? 0 },
    no()         { return this.valores?.[1] ?? 0 },
    total()      { return this.si + this.no },
    pct()        { return this.total ? (this.si / this.total) * 100 : 0 },
    pctLabel()   { return this.pct.toFixed(1) + '%' },
    arcLength()  { return ARC_LENGTH },
    dashoffset() { return ARC_LENGTH * (1 - this.pct / 100) },
    color() {
      if (this.pct >= 80) return '#3f51b5'
      if (this.pct >= 60) return '#e65100'
      return '#c62828'
    },
  },
}
</script>

<style scoped>
.gauge-inner { width: 100%; display: flex; flex-direction: column; align-items: center; }
.gauge-svg-wrap { position: relative; width: 130px; }
.gauge-svg-wrap svg { width: 100%; display: block; }
.gauge-label { position: absolute; bottom: 2px; left: 50%; transform: translateX(-50%); text-align: center; white-space: nowrap; }
.gauge-pct { display: block; font-size: 1.3rem; font-weight: 800; line-height: 1; }
.gauge-sub { display: block; font-size: 0.62rem; color: #90a4ae; text-transform: uppercase; letter-spacing: 0.5px; margin-top: 1px; }
.gauge-counts { display: flex; gap: 16px; margin-top: 12px; }
.gauge-count { font-size: 0.75rem; color: #78909c; display: flex; align-items: center; gap: 4px; }
.gauge-count strong { color: #37474f; font-weight: 700; }
.gauge-count.si i { color: #3f51b5; font-size: 0.75rem; }
.gauge-count.no i { color: #b0bec5; font-size: 0.75rem; }
</style>
